module.exports = __webpack_public_path__ + "img/OffHover.73a91dfc.svg";